export default __webpack_public_path__ + "static/media/AdminInactiveLight.49bd2104.svg";